// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--a2fe4";
export var gradiantBorder = "footer-module--gradiantBorder--14547";
export var socialMediaIcons = "footer-module--socialMediaIcons--3488b";